<template>
  <div>
    <div v-if="showModal" class="vue-modal-overlay">
          <div class="vue-modal-content scan-modal">
          <div class="scan-modal-left">
            <button class="close-btn" @click="showModal = false">
                <img src="../../../../static/website/images/cross-icon.svg" alt="Close" />
             </button>
            <!-- <h2 class="scan-title">Scan to Open an Account</h2> -->
            <div class="qr-wrapper">
            <img
                src="../../../../static/website/images/live-qr.svg"
                alt="Scan to install Shoonya App"
                class="qr-image"
                width="250"
                height="250"
            />
            </div>
            <div class="app-links">
                <div class="store-card" @click="redirectToAndroidStore" style="cursor: pointer;">
                    <img src="../../../../static/website/images/google-play.png" alt="Google Play" class="store-icon" />
                    <div class="store-text">
                    <span class="store-title">Google Play</span>
                    <span class="store-rating">4.5 <span class="star"><img src="../../../../static/website/images/star.svg"  class="star-icon" /></span></span>
                    </div>
                </div>
                <div class="store-card"  @click="redirectToIphoneStore" style="cursor: pointer;">
                    <img src="../../../../static/website/images/app-store.png" alt="App Store" class="store-icon" />
                    <div class="store-text">
                    <span class="store-title">App Store</span>
                    <span class="store-rating">4.5 <span class="star"><img src="../../../../static/website/images/star.svg"  class="star-icon" /></span></span>
                    </div>
                </div>
            </div>
          </div>
          <div class="scan-modal-right">
            <div class="scan-modal-right-container">
              <h1 class="scan-modal-right-title">Start Your Investment Journey with Shoonya</h1>

              <div class="scan-modal-right-steps">
                <!-- Step 1 -->
                <div class="scan-modal-right-step">
                  <img src="../../../../static/website/images/radio-step.svg" alt="dots" class="scan-modal-right-step-icon" />
                  <div class="scan-modal-right-step-content">
                    <div class="scan-modal-right-step-label">STEP 1</div>
                    <div class="scan-modal-right-step-text">Scan the QR to Get the App</div>
                  </div>
                </div>

                <!-- Connector Line -->
                <div class="scan-modal-right-step-connector"></div>

                <!-- Step 2 -->
                <div class="scan-modal-right-step">
                  <img src="../../../../static/website/images/radio-step.svg" alt="dots" class="scan-modal-right-step-icon" />
                  <div class="scan-modal-right-step-content">
                    <div class="scan-modal-right-step-label">STEP 2</div>
                    <div class="scan-modal-right-step-text">Tap "Register Now”</div>
                  </div>
                </div>
              </div>

              <!-- Footer -->
              <div class="scan-modal-right-footer">
                <span>Need Help?</span>
                <a href="https://www.youtube.com/watch?v=4KXEe_2mFRI" target="_blank" class="scan-modal-right-see-link">
                  <span class="scan-modal-right-play-icon"><img src="../../../../static/website/images/play-youtube-icon.svg"/></span>
                  <span>Learn How It Works</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        </div>
    <section id="fix_enginee" class="blockElement banner pb-0">
      <div class="container" align="center">
        <div class="row text-center justify-content-center">
          <div class="col-12">
            <div class="banner_text text-center">
              <h1 class="mb-0">High Networth <br /><span>Investors</span></h1>
            </div>
            <img class="img-fluid"  width="777" height="288"
              src="../../../../static/website/images/hni_banner_thumb.webp"
              alt="High Networth Investors" title="High Networth Investors"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="blockElement aboutUs pt-4">
      <div class="container">
        <div class="row text-center justify-content-center">
          <div class="col-11">
            <div class="bottom-shadow whiteBoard">
              <p>
                Shoonya offers wealth management solutions to High Net Worth
                Individuals (HNIs) who are based in India and overseas (NRIs).
                Clients with an investable surplus of more than Rs 25 Lacs are
                serviced by our HNI team.
              </p>
              <p>
                We offer HNIs a range of researched backed, customised
                investment solutions allowing them to invest in Structured
                Products, Equities, Commodities, Mutual Funds and Real Estate.
                We put our clients first ensuring that they reap the benefits
                from the investments.
              </p>
              <div class="customBtn-bt">
                <a
                  class="fin_btn darkBG"
                  @click.prevent="handleWebEngageEvent"
                  >Open An Account</a
                >
              </div>
            </div>
            <div class="cta blob part" data-num="1">
              <img
                src="../../../../static/website/images/footer-blob1.svg"
                alt="Icon"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="blockElement bg">
      <div class="container">
        <div class="head-title text-center brown-p">
          <h2>The <span>Process</span></h2>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="main-timeline">
              <div class="timeline">
                <div class="timeline-content">
                  <div class="timeline-icon">1</div>
                  <h3 class="title">
                    We understand clients investment objectives
                  </h3>
                </div>
              </div>
              <div class="timeline">
                <div class="timeline-content">
                  <div class="timeline-icon">2</div>
                  <h3 class="title">
                    Analyse client's financial profile & risk appetite
                  </h3>
                </div>
              </div>
              <div class="timeline">
                <div class="timeline-content">
                  <div class="timeline-icon">3</div>
                  <h3 class="title">Develop a suitable investment plan</h3>
                </div>
              </div>
              <div class="timeline">
                <div class="timeline-content">
                  <div class="timeline-icon">4</div>
                  <h3 class="title">
                    Execute the plan by leveraging our resources
                  </h3>
                </div>
              </div>
              <div class="timeline">
                <div class="timeline-content">
                  <div class="timeline-icon">5</div>
                  <h3 class="title">Ongoing risk management</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section id="why_hni" class="blockElement servc_offrd darkBG">
            <div class="container">
                <div class="head-title text-center mb-4">
                    <h2>Why HNI with <span>Shoonya?</span></h2>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-6">
                        <ul class="dotIcon light">
                            <li><check-icon size="1.5x" class="custom-class"></check-icon> Highly advanced technology and softwares to utilize and maintain the wealth of the individuals.</li>
                            <li><check-icon size="1.5x" class="custom-class"></check-icon> Strong team of expert professionals offering solutions to achieve unique investment objectives.</li>
                            <li><check-icon size="1.5x" class="custom-class"></check-icon> Actively monitoring the investments to optimize the best results for the individuals.</li>
                            <li><check-icon size="1.5x" class="custom-class"></check-icon> HNIs are given to have a complete full access to track their own portfolio.</li>
                            <li><check-icon size="1.5x" class="custom-class"></check-icon> Covering the multiple solutions for each asset class for the individuals.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <app-seo></app-seo>
        </section> -->
    <section class="blockElement">
      <div class="container">
        <div class="head-title text-center brown-p">
          <h2>Products <span>Offers</span></h2>
        </div>
        <div class="finCustomTabs">
          <div class="row justify-content-center">
            <div class="col-12 col-md-10">
              <div class="row">
                <div class="col-12 col-md-5">
                  <div
                    class="nav flex-column nav-pills"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <ul class="tabs nav-tabs" id="myTab">
                      <li
                        class="nav-item"
                        v-for="tab in tabs"
                        @click.prevent="setActiveTabName(tab.name)"
                      >
                        <a
                          class="nav-link"
                          href="#"
                          v-bind:class="
                            tab.name == activeTabName ? 'active' : ''
                          "
                          >{{ tab.displayName }}</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-12 col-md-7">
                  <div
                    class="tab_container tab-content hideMob-t"
                    id="myTabContent"
                  >
                    <h3
                      class="d_active tab_drawer_heading"
                      rel="tab1"
                      @click.prevent="setActiveTabName('overview1')"
                      v-bind:class="
                        activeTabName == 'overview1' ? 'active' : ''
                      "
                    >
                      Structured Products
                    </h3>
                    <div
                      id="tab1"
                      class="tab_content"
                      v-if="activeTabName == 'overview1'"
                    >
                      <div class="bottom-shadow whiteBoard">
                        <div class="bottom-hni">
                          <div class="ico">
                            <img class="img-fluid" width="121" height="100"
                              src="../../../../static/website/images/hni.svg"
                              alt="products offer" title="products offer"
                            />
                          </div>
                          <p>
                            Apt for high net-worth investors, Structured
                            Products have a unique risk-return profile that
                            allows principal protection to a certain level.
                            These products are tailor made to accommodate the
                            investment profile and risk appetite of clients.
                          </p>
                          <!-- <a class="gray underline" href="#">Discover More  <i data-feather="chevron-right"></i></a> -->
                        </div>
                      </div>
                      <div class="cta blob part" data-num="1">
                        <img
                          src="../../../../static/website/images/footer-blob1.svg"
                          alt="Icon"
                        />
                      </div>
                    </div>
                    <h3
                      class="d_active tab_drawer_heading"
                      rel="tab2"
                      @click.prevent="setActiveTabName('overview')"
                      v-bind:class="activeTabName == 'overview' ? 'active' : ''"
                    >
                      Equities
                    </h3>
                    <div
                      id="tab2"
                      class="tab_content"
                      v-if="activeTabName == 'overview'"
                    >
                      <div class="bottom-shadow whiteBoard">
                        <div class="bottom-hni">
                          <div class="ico">
                            <img class="img-fluid" width="121" height="100"
                              src="../../../../static/website/images/hni.svg"
                              alt="products offer" title="products offer"
                            />
                          </div>
                          <p>
                            Our research team evaluates the financial strength
                            of companies, sectors and investment themes so that
                            our HNIs clients can make informed decisions about
                            their equity portfolio.
                          </p>
                          <!-- <a class="gray underline" href="#">Discover More  <i data-feather="chevron-right"></i></a> -->
                        </div>
                      </div>
                      <div class="cta blob part" data-num="1">
                        <img
                          src="../../../../static/website/images/footer-blob1.svg"
                          alt="Icon"
                        />
                      </div>
                    </div>
                    <!-- #tab1 -->
                    <h3
                      class="tab_drawer_heading"
                      rel="tab3"
                      @click.prevent="setActiveTabName('about')"
                      v-bind:class="activeTabName == 'about' ? 'active' : ''"
                    >
                      Commodities
                    </h3>
                    <div
                      id="tab3"
                      class="tab_content"
                      v-if="activeTabName == 'about'"
                    >
                      <div class="bottom-shadow whiteBoard">
                        <div class="bottom-hni">
                          <div class="ico">
                            <img class="img-fluid" width="121" height="100"
                              src="../../../../static/website/images/hni.svg"
                              alt="products offer" title="products offer"
                            />
                          </div>
                          <p>
                            HNIs can make the most out of the lucrative agri and
                            non agri commodities market with advice from
                            Shoonya’s research team. Please note that this
                            segment is not offered to NRI High Net Worth
                            Individuals
                          </p>
                        </div>
                      </div>
                      <div class="cta blob part" data-num="1">
                        <img
                          src="../../../../static/website/images/footer-blob1.svg"
                          alt="Icon"
                        />
                      </div>
                    </div>
                    <!-- #tab2 -->
                    <h3
                      class="tab_drawer_heading"
                      rel="tab4"
                      @click.prevent="setActiveTabName('check')"
                      v-bind:class="activeTabName == 'check' ? 'active' : ''"
                    >
                      Mutual Funds
                    </h3>
                    <div
                      id="tab4"
                      class="tab_content"
                      v-if="activeTabName == 'check'"
                    >
                      <div class="bottom-shadow whiteBoard">
                        <div class="bottom-hni">
                          <div class="ico">
                            <img class="img-fluid" width="121" height="100"
                              src="../../../../static/website/images/hni.svg"
                              alt="products offer" title="products offer"
                            />
                          </div>
                          <p>
                            Our research specialists help you choose the right
                            funds that meet your long term financial objectives.
                            They assess your risk profile, examine the fund’s
                            track record before shortlisting the funds for you.
                          </p>
                        </div>
                      </div>
                      <div class="cta blob part" data-num="1">
                        <img
                          src="../../../../static/website/images/footer-blob1.svg"
                          alt="Icon"
                        />
                      </div>
                    </div>
                    <h3
                      class="tab_drawer_heading"
                      rel="tab5"
                      @click.prevent="setActiveTabName('check1')"
                      v-bind:class="activeTabName == 'check1' ? 'active' : ''"
                    >
                      Real Estate
                    </h3>
                    <div
                      id="tab5"
                      class="tab_content"
                      v-if="activeTabName == 'check1'"
                    >
                      <div class="bottom-shadow whiteBoard">
                        <div class="bottom-hni">
                          <div class="ico">
                            <img class="img-fluid" width="121" height="100"
                              src="../../../../static/website/images/hni.svg"
                              alt="products offer" title="products offer"
                            />
                          </div>
                          <p>
                            We help HNI clients in making the right property
                            investments decisions, right from finalizing the
                            property to closing the deal. Shoonya also assists
                            in financing the property through various financial
                            intermediaries.
                          </p>
                          <!-- <a class="gray underline" href="#">Discover More  <i data-feather="chevron-right"></i></a> -->
                        </div>
                      </div>
                      <div class="cta blob part" data-num="1">
                        <img
                          src="../../../../static/website/images/footer-blob1.svg"
                          alt="Icon"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="blockElement position-relative">
      <div class="container">
        <div class="head-title text-center">
          <h2>Get in <span>Touch</span></h2>
        </div>
        <div class="row align-items-center">
          <div class="col-12 col-md-6">
            <div class="getIn-imag">
              <img class="img-fluid" width="432" height="385"
                src="../../../../static/website/images/4111240.svg"
                alt="get in touch" title="get in touch"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <appgetinTouch :page="'hni'"></appgetinTouch>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import SEO from "../shared/SEO";
import VueFaqAccordion from "vue-faq-accordion";
import { CheckIcon } from "vue-feather-icons";
import getinTouch from "../shared/contactform/getintouch";
export default {
  name: "app",
  data() {
    return {
      prismRegisterPath: process.env.PRISM_REGISTER,
      showModal: false,
      tabs: [
        {
          name: "overview1",
          displayName: "Structured Products",
        },
        {
          name: "overview",
          displayName: "Equities",
        },
        {
          name: "about",
          displayName: "Commodities",
        },
        {
          name: "check",
          displayName: "Mutual Funds",
        },
        {
          name: "check1",
          displayName: "Real Estate",
        },
      ],
      activeTabName: null,
    };
  },
  components: {
    VueFaqAccordion,
    appSeo: SEO,
    CheckIcon,
    appgetinTouch: getinTouch,
  },
  methods: {
    setActiveTabName(name) {
      this.activeTabName = name;
    },
     handleWebEngageEvent() {
      const isMobile = window.matchMedia("(max-width: 768px)").matches;

        if (isMobile) {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

                 const isSafariMobile = /^((?!chrome|android).)*safari/i.test(userAgent) && /iPad|iPhone|iPod/.test(userAgent);
                const isAndroidMobile = /android/i.test(userAgent);
                if (isSafariMobile) {
                    // Mobile Safari (iOS)
                    window.open("https://apps.apple.com/in/app/shoonya/id1539034076", "_blank");
                } else if (isAndroidMobile) {
                    // Android (Chrome or other browser)
                    window.open("https://play.google.com/store/apps/details?id=com.rs.shoonya&hl=en", "_blank");
                } else {
                    // Default fallback (other mobile browsers)
                    window.open("/", "_blank");
                }
            } else {
                this.showModal = true;
            }
    },

        redirectToAndroidStore() {
            window.open("https://play.google.com/store/apps/details?id=com.rs.shoonya&hl=en");
          
        },
        redirectToIphoneStore() {
                window.open("https://apps.apple.com/in/app/shoonya/id1539034076");
           
        }
  },
  computed: {},
  mounted() {
    this.activeTabName = this.tabs[0].name;
    window.scroll(0, 0);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/shared/hni.vue